const project_entry = () => import("@/view/projectentry/components/index")
const ademo = () => import("@/view/ademo/ceshi") //demo表
const no_power = () => import("@/view/nopower")
const project_edit = () => import("@/view/tender/project/project-edit")
//项目归档-zhuyl
const project_filed_main = () => import("@/view/tender/projectfiled/projectfiled-main")
const project_filed_tender_edit = () => import("@/view/tender/projectfiled/projectfiled-edit")
const project_filed_tender_view = () => import("@/view/tender/projectfiled/projectfiled-view")
const project_filed_tender_pdf = () => import("@/view/tender/projectfiled/projectFiled-pdf")
//报价形式设置
const price_form_list = () => import("@/view/tender/priceform/price-form-list")
const price_form_detail = () => import("@/view/tender/priceform/price-form-detail")
// 执行通知书-edit
const carry_out_notice_edit = () => import("@/view/tender/carryoutnotice/carry-out-notice-edit")
//单一来源公示
const single_source_notice_main = () => import("@/view/tender/singlesourcenotice/single-source-notice-main")
const single_source_notice_view = () => import("@/view/tender/singlesourcenotice/single-source-notice-view")
const single_source_notice_edit = () => import("@/view/tender/singlesourcenotice/single-source-notice-edit")
const single_source_notice_apply_view = () => import("@/view/tender/singlesourcenotice/single-source-notice-apply-view")
// 评审专家登记-list
const review_expert_registration_list = () => import("@/view/evaluation/reviewexpertregistration/review-expert-registration-list")
// 评审专家登记-edit
const review_expert_registration_edit = () => import("@/view/evaluation/reviewexpertregistration/review-expert-registration-edit")
//资审公告编制
const qualification_audit_detail = () => import("@/view/tender/qualificationauditnotice/qualification-audit-detail")
const qualification_audit_contest_pdf = () => import("@/view/tender/qualificationauditnotice/qualification-audit-contest-pdf")
//资审公告核验
const procrement_file_detail_contest = () => import("@/view/tender/procrementfiledetail/contest/procrement-file-detail-contest")
const procrement_notice_contest_pdf = () => import("@/view/tender/procrementfiledetail/contest/procrement-notice-contest-pdf")
//公开，不走执行通知书
const procrement_file_detail_notcarry_pdf = () => import("@/view/tender/procrementfiledetail/procrement/procrement-file-detail-notcarry-pdf")
// 竞谈-谈判邀请书编制
const procrement_notice_contest_invitation = () => import("@/view/tender/procrementfiledetail/contest/procrement-notice-contest-invitation")
const procrement_notice_contest_invitation_pdf = () => import("@/view/tender/procrementfiledetail/contest/procrement-notice-contest-invitation-pdf")

/*邀请书及文件编制-开始*/
//列表
const procrement_file_detail_invitation_list = () => import("@/view/tender/procrementfiledetail/invitation/list")
//投标
const procrement_file_detail_invitation_bid_notice = () => import("@/view/tender/procrementfiledetail/invitation/bid/view/notice")
const procrement_file_detail_invitation_bid_company = () => import("@/view/tender/procrementfiledetail/invitation/bid/view/company")
const procrement_file_detail_invitation_bid_file = () => import("@/view/tender/procrementfiledetail/invitation/bid/view/file")
//竟磋
const procrement_file_detail_invitation_competition_notice = () => import("@/view/tender/procrementfiledetail/invitation/competition/view/notice")
const procrement_file_detail_invitation_competition_company = () => import("@/view/tender/procrementfiledetail/invitation/competition/view/company")
const procrement_file_detail_invitation_competition_file = () => import("@/view/tender/procrementfiledetail/invitation/competition/view/file")
//竟谈
const procrement_file_detail_invitation_negotiation_notice = () => import("@/view/tender/procrementfiledetail/invitation/negotiation/view/notice")
const procrement_file_detail_invitation_negotiation_company = () => import("@/view/tender/procrementfiledetail/invitation/negotiation/view/company")
const procrement_file_detail_invitation_negotiation_file = () => import("@/view/tender/procrementfiledetail/invitation/negotiation/view/file")
//询价
const procrement_file_detail_invitation_inquiry_notice = () => import("@/view/tender/procrementfiledetail/invitation/inquiry/view/notice")
const procrement_file_detail_invitation_inquiry_company = () => import("@/view/tender/procrementfiledetail/invitation/inquiry/view/company")
const procrement_file_detail_invitation_inquiry_file = () => import("@/view/tender/procrementfiledetail/invitation/inquiry/view/file")
//单一信封
const procrement_file_detail_invitation_onesource_notice = () => import("@/view/tender/procrementfiledetail/invitation/onesource/view/notice")
const procrement_file_detail_invitation_onesource_company = () => import("@/view/tender/procrementfiledetail/invitation/onesource/view/company")
const procrement_file_detail_invitation_onesource_file = () => import("@/view/tender/procrementfiledetail/invitation/onesource/view/file")
//预审
const procrement_file_detail_invitation_pretrial_notice = () => import("@/view/tender/procrementfiledetail/invitation/pretrial/view/notice")
const procrement_file_detail_invitation_pretrial_company = () => import("@/view/tender/procrementfiledetail/invitation/pretrial/view/company")
const procrement_file_detail_invitation_pretrial_file = () => import("@/view/tender/procrementfiledetail/invitation/pretrial/view/file")
//核验-列表
const procrement_file_invitation_approval_list = () => import("@/view/tender/procrementfileapproval/invitation/procrement-file-invitation-approval-list")
/*邀请书及文件编制-结束*/

//资审公告及文件编制
const procrement_file_detail_review = () => import("@/view/tender/procrementfiledetail/proclamationreview/list")
const procrement_file_detail_review_notice = () => import("@/view/tender/procrementfiledetail/proclamationreview/notice")
const procrement_file_detail_review_file = () => import("@/view/tender/procrementfiledetail/proclamationreview/file")
//资审公告及文件核验
const procrement_file_review_approval_list = () => import("@/view/tender/procrementfiledetail/proclamationreview/verification")

//采购公告及文件编制
const procrement_file_detail = () => import("@/view/tender/procrementfiledetail/list")
const procrement_file_detail_notice = () => import("@/view/tender/procrementfiledetail/purchase/notice")
const procrement_file_detail_file = () => import("@/view/tender/procrementfiledetail/purchase/file")
//磋商公告及文件编制
const procrement_file_detail_competition_notice = () => import("@/view/tender/procrementfiledetail/competition/view/notice")
const procrement_file_detail_competition_file = () => import("@/view/tender/procrementfiledetail/competition/view/file")
//谈判公告及文件编制
const procrement_file_detail_negotiation_notice = () => import("@/view/tender/procrementfiledetail/negotiation/view/notice")
const procrement_file_detail_negotiation_file = () => import("@/view/tender/procrementfiledetail/negotiation/view/file")
// 竞磋-竞磋公告查看
const procrement_file_detail_competition_pdf = () => import("@/view/tender/procrementfiledetail/competition/procrement-file-detail-competition-pdf")
//竞磋-磋商邀请书编制
const procrement_file_detail_competition_invitation = () => import("@/view/tender/procrementfiledetail/competition/invitation/procrement-file-detail-competition-invitation")
//竞磋-磋商邀请书查看
const procrement_file_detail_competition_invitation_pdf = () => import("@/view/tender/procrementfiledetail/competition/invitation/procrement-file-detail-competition-invitation-pdf")
//询价-询价文件编制

const procrement_file_detail_inquiry = () => import("@/view/tender/procrementfiledetail/inquiry/procrement-file-detail-inquiry")
//询价-询价文件编制PDF查看

const procrement_file_detail_inquiry_pdf = () => import("@/view/tender/procrementfiledetail/inquiry/procrement-file-detail-inquiry-pdf")
//询价-询价邀请书编制

const procrement_file_detail_inquiry_invitation = () => import("@/view/tender/procrementfiledetail/inquiry/incitation/procrement-file-detail-inquiry-invitation")
//询价-询价邀请书PDF查看

const procrement_file_detail_inquiry_invitation_pdf = () => import("@/view/tender/procrementfiledetail/inquiry/incitation/procrement-file-detail-inquiry-invitation-pdf.vue")
//询价-公告及文件编制

const procrement_file_detail_inquiry_notice = () => import("@/view/tender/procrementfiledetail/inquiry/view/notice")

const procrement_file_detail_inquiry_file = () => import("@/view/tender/procrementfiledetail/inquiry/view/file")
//单一来源-谈判邀请函编制

const procrement_file_detail_onesource = () => import("@/view/tender/procrementfiledetail/onesource/procrement-file-detail-onsource")
//单一来源-谈判PDF查看

const procrement_file_detail_onesource_pdf = () => import("@/view/tender/procrementfiledetail/onesource/procrement-file-detail-onsource-pdf")
//单一来源公告及文件编制

const procrement_file_detail_onesource_notice = () => import("@/view/tender/procrementfiledetail/onesource/view/notice")

const procrement_file_detail_onesource_file = () => import("@/view/tender/procrementfiledetail/onesource/view/file")
// 邀请书路由开始
// 邀请书后审编辑路由

const procrement_notice_invitation_two_envelope = () => import("@/view/tender/procrementfiledetail/invitation/twoenvelope/procrement-notice-invitation-two-envelope")
// 邀请书后审PDF查看路由

const procrement_notice_invitation_two_envelope_pdf = () => import("@/view/tender/procrementfiledetail/invitation/twoenvelope/procrement-notice-invitation-two-envelope-pdf")
// 邀请预审编辑路由

const procrement_notice_invitation_pretrial = () => import("@/view/tender/procrementfiledetail/invitation/pretrial/procrement-notice-invitation-pretrial")
// 邀请预审列表路由

const procrement_notice_invitation_pretrial_list = () => import("@/view/tender/procrementfiledetail/invitation/pretrial/procrement-notice-invitation-pretrial-list")
// 邀请预审PDF编辑路由

const procrement_notice_invitation_pretrial_pdf = () => import("@/view/tender/procrementfiledetail/invitation/pretrial/procrement-notice-invitation-pretrial-pdf")
// 邀请书路由结束

const nullifield_bid_list = () => import("@/view/exception/nullifieldbid/nullifield-bid-list")

const nullifield_bid_edit = () => import("@/view/exception/nullifieldbid/nullifield-bid-edit")

const nullifield_bid_view = () => import("@/view/exception/nullifieldbid/nullifield-bid-view")
//中标结果公告-list
const win_bid_announcement_list = () => import("@/view/awardnotice/winbidannouncement/win-bid-announcement-list")
//中标结果公告-edit
const win_bid_announcement_edit = () => import("@/view/awardnotice/winbidannouncement/win-bid-announcement-edit")
//中标结果公告-release
const win_bid_announcement_release = () => import("@/view/awardnotice/winbidannouncement/win-bid-announcement-release")

//查看报名情况
const enroll_view_list = () => import("@/view/bidding/enrollview/enroll-view-list")

//开标结果记录
const open_bid_result_list = () => import("@/view/evaluation/openbidresult/open-bid-result-list")
const open_bid_result_edit = () => import("@/view/evaluation/openbidresult/open-bid-result-edit")
const open_bid_result_view = () => import("@/view/evaluation/openbidresult/open-bid-result-view")
//信息更正公告-公开
const modify_correction_view = () => import("@/view/tender/modifynotice/mod-correction-view")
const modify_notice_list = () => import("@/view/tender/modifynotice/modify-notice-list")
const modify_notice_edit = () => import("@/view/tender/modifynotice/modify-notice-edit")
const modify_notice_view = () => import("@/view/tender/modifynotice/modify-notice-view")
const modify_notice_pdf = () => import("@/view/tender/modifynotice/modify-notice-pdf")
//信息更正公告，采购代理信息
const purchase_agency = () => import("@/view/tender/modifynotice/common/purchase-agency")
//采购人信息
const purchaser_connector = () => import("@/view/tender/modifynotice/common/purchaser-connector")
//项目信息
const project_info = () => import("@/view/tender/modifynotice/common/project-info")
//更正信息
const monify_notice_info = () => import("@/view/tender/modifynotice/common/monify-notice-info")

//信息更正公告-邀请

const modify_invite_correction_view = () => import("@/view/tender/modifynotice/invite/mod-invite-correction-view")

const modify_notice_invite_list = () => import("@/view/tender/modifynotice/invite/modify-notice-invite-list")

const modify_notice_invite_edit = () => import("@/view/tender/modifynotice/invite/modify-notice-invite-edit")

const modify_notice_invite_view = () => import("@/view/tender/modifynotice/invite/modify-notice-invite-view")

const modify_notice_invite_pdf = () => import("@/view/tender/modifynotice/invite/modify-notice-invite-pdf")

//信息更正公告-竞谈
const modify_notice_contest_list = () => import("@/view/tender/modifynotice/contest/modify-notice-contest-list")

const modify_contest_correction_view = () => import("@/view/tender/modifynotice/contest/mod-contest-correction-view")

const modify_notice_contest_edit = () => import("@/view/tender/modifynotice/contest/modify-notice-contest-edit")

const modify_notice_contest_view = () => import("@/view/tender/modifynotice/contest/modify-notice-contest-view")

const modify_notice_contest_pdf = () => import("@/view/tender/modifynotice/contest/modify-notice-contest-pdf")
//信息更正公告-竞磋

const mod_competion_correction_view = () => import("@/view/tender/modifynotice/competition/mod-competion-correction-view")

const modify_notice_competition_list = () => import("@/view/tender/modifynotice/competition/modify-notice-competition-list")

const modify_notice_competition_edit = () => import("@/view/tender/modifynotice/competition/modify-notice-competition-edit")

const modify_notice_competition_view = () => import("@/view/tender/modifynotice/competition/modify-notice-competition-view")

const modify_notice_competition_pdf = () => import("@/view/tender/modifynotice/competition/modify-notice-competition-pdf")
//信息更正公告-询价

const modify_inquiry_correction_view = () => import("@/view/tender/modifynotice/inquiry/mod-inquiry-correction-view")

const modify_notice_inquiry_list = () => import("@/view/tender/modifynotice/inquiry/modify-notice-inquiry-list")

const modify_notice_inquiry_edit = () => import("@/view/tender/modifynotice/inquiry/modify-notice-inquiry-edit")

const modify_notice_inquiry_view = () => import("@/view/tender/modifynotice/inquiry/modify-notice-inquiry-view")

const modify_notice_inquiry_pdf = () => import("@/view/tender/modifynotice/inquiry/modify-notice-inquiry-pdf")
//信息更正公告-单一来源

const modify_onesource_correction_view = () => import("@/view/tender/modifynotice/onesource/mod-onesource-correction-view")

const modify_notice_onesource_list = () => import("@/view/tender/modifynotice/onesource/modify-notice-onesource-list")

const modify_notice_onesource_edit = () => import("@/view/tender/modifynotice/onesource/modify-notice-onesource-edit")

const modify_notice_onesource_view = () => import("@/view/tender/modifynotice/onesource/modify-notice-onesource-view")

const modify_notice_onesource_pdf = () => import("@/view/tender/modifynotice/onesource/modify-notice-onesource-pdf")
//资审更正公告

const qualification_audit_notice_modify_list = () => import("@/view/tender/qualificationauditnoticemodify/qualification-audit-notice-modify-list")

const qualification_audit_notice_modify_edit = () => import("@/view/tender/qualificationauditnoticemodify/qualification-audit-notice-modify-edit")

const qualification_audit_notice_modify_view = () => import("@/view/tender/qualificationauditnoticemodify/qualification-audit-notice-modify-view")

const qualification_audit_notice_modify_pdf = () => import("@/view/tender/qualificationauditnoticemodify/qualification-audit-notice-modify-pdf")

const qualification_audit_modify_correction_view = () => import("@/view/tender/qualificationauditnoticemodify/qualification-audit-modify-correction-view")
//资审更正公告代理信息

const qualification_purchase_agency = () => import("@/view/tender/qualificationauditnoticemodify/common/qualification-purchase-agency")
//资审更正公告项目信息

const qualification_project_info = () => import("@/view/tender/qualificationauditnoticemodify/common/qualification-project-info")
//资审更正公告采购人信息

const qualification_purchaser_connector = () => import("@/view/tender/qualificationauditnoticemodify/common/qualification-purchaser-connector")
//资审更正公告信息

const qualification_monify_notice_info = () => import("@/view/tender/qualificationauditnoticemodify/common/qualification-monify-notice-info")


//资格审查结果记录

const qualification_audit_record_list = () => import("@/view/evaluation/qualificationauditrecord/qualification-audit-record-list")

const qualification_audit_record_edit = () => import("@/view/evaluation/qualificationauditrecord/qualification-audit-record-edit")

const qualification_audit_record_view = () => import("@/view/evaluation/qualificationauditrecord/qualification-audit-record-view")
//评审结果记录

const evaluation_bid_result_list = () => import("@/view/evaluation/evaluationbidresult/evaluation-bid-result-list")

const evaluation_bid_result_edit = () => import("@/view/evaluation/evaluationbidresult/evaluation-bid-result-edit")

const evaluation_bid_result_view = () => import("@/view/evaluation/evaluationbidresult/evaluation-bid-result-view")
//合同公示

const contract_publicity_list = () => import("@/view/contract/contractpublicity/contract-publicity-list")

const contract_publicity_edit = () => import("@/view/contract/contractpublicity/contract-publicity-edit")

const contract_publicity_view = () => import("@/view/contract/contractpublicity/contract-publicity-view")

const contract_publicity_pdf = () => import("@/view/contract/contractpublicity/contract-publicity-pdf")

const contract_publicity_pdffzr = () => import("@/view/contract/contractpublicity/contract-publicity-pdffzr")

//项目论证-第一页

const project_arguement_first = () => import("@/view/tender/projectarguementation/project-arguement-first")
//项目论证-第二页

const project_arguement_second = () => import("@/view/tender/projectarguementation/project-arguement-second")
//供应商质疑回复 项目负责人-list

const answer_project_list = () => import("@/view/bidding/answerproject/answer-project-list")
//供应商质疑回复 项目负责人-reply

const answer_project_reply = () => import("@/view/bidding/answerproject/answer-project-reply")
//供应商质疑回复 项目负责人-detail

const answer_project_detail = () => import("@/view/bidding/answerproject/answer-project-detail")
//供应商质疑回复 项目负责人-receipt

const answer_project_receipt = () => import("@/view/bidding/answerproject/answer-project-receipt")
//踏勘结果登记-list

const survey_result_record_list = () => import("@/view/tender/surveyresultrecord/survey-result-record-list")
//踏勘结果登记-edit

const survey_result_record_edit = () => import("@/view/tender/surveyresultrecord/survey-result-record-edit")
//踏勘结果登记-view

const survey_result_record_view = () => import("@/view/tender/surveyresultrecord/survey-result-record-view")
//标后更正公告

const win_bid_notice_modify_list = () => import("@/view/awardnotice/winbidnoticemodify/win-bid-notice-modify-list")

const win_bid_notice_modify_edit = () => import("@/view/awardnotice/winbidnoticemodify/win-bid-notice-modify-edit")

const win_bid_notice_modify_pdf = () => import("@/view/awardnotice/winbidnoticemodify/win-bid-notice-modify-pdf")

const win_bid_notice_modify_view_pdf = () => import("@/view/awardnotice/winbidnoticemodify/win-bid-notice-modify-view-pdf")

const win_bid_notice_modify_view = () => import("@/view/awardnotice/winbidnoticemodify/win-bid-notice-modify-view")

//复评申请

const reaccreditation_apply_list = () => import("@/view/evaluation/reaccreditationapply/reaccreditation-apply-list")

const reaccreditation_apply_edit = () => import("@/view/evaluation/reaccreditationapply/reaccreditation-apply-edit")

const reaccreditation_apply_view = () => import("@/view/evaluation/reaccreditationapply/reaccreditation-apply-view")
//复评结果

const reaccreditation_conclusion_list = () => import("@/view/evaluation/reaccreditationconclusion/reaccreditation-conclusion-list")

const reaccreditation_conclusion_edit = () => import("@/view/evaluation/reaccreditationconclusion/reaccreditation-conclusion-edit")

const reaccreditation_conclusion_view = () => import("@/view/evaluation/reaccreditationconclusion/reaccreditation-conclusion-view")

const project_correction_view = () => import("@/view/tender/projectcorrection/project-correction-view")

const qualification_audit_correction_view = () => import("@/view/tender/qualificationauditnoticecorrection/qualification-audit-correction-view")

//变更评委申请list

const change_judge_application_list = () => import("@/view/evaluation/changejudgeapplication/change-judge-application-list")
//变更评委申请edit

const change_judge_application_edit = () => import("@/view/evaluation/changejudgeapplication/change-judge-application-edit")
//变更采购方式-list

const change_purchaser_mode_list = () => import("@/view/evaluation/changepurchasermode/change-purchaser-mode-list")
//变更采购方式-edit

const change_purchaser_mode_edit = () => import("@/view/evaluation/changepurchasermode/change-purchaser-mode-edit")
//场地预约 列表

const project_venue_book_reserve = () => import("@/view/tender/projectvenuebook/project-venue-book-reserve")
//场地预约 列表

const project_venue_book_venue = () => import("@/view/tender/projectvenuebook/project-venue-book-venue")
//场地预约

const venue_book = () => import("@/view/tender/venuebook/index")

const venue_book_list = () => import("@/view/tender/venuebook/src/list")

const venue_book_info = () => import("@/view/tender/venuebook/src/info")
//资审场地预约

const venue_book_review = () => import("@/view/tender/venuebookreview/index")

const venue_book_review_list = () => import("@/view/tender/venuebookreview/src/list")

const venue_book_review_info = () => import("@/view/tender/venuebookreview/src/info")
//单一来源场地预约

const venue_book_single = () => import("@/view/tender/venuebooksingle/index")

const venue_book_single_list = () => import("@/view/tender/venuebooksingle/src/list")

const venue_book_single_info = () => import("@/view/tender/venuebooksingle/src/info")

const project_filed_edit = () => import("@/view/exception/projectfiled/project-filed-edit")

const project_filed_view = () => import("@/view/exception/projectfiled/project-filed-view")

//采购文件上传和核验
const purchase_file_verification_edit = () => import("@/view/fileVerification/purchase-file-verification-edit")
//资审文件上传和核验
const information_file_verification_edit = () => import("@/view/fileVerification/information-file-verification-edit")

//无效中标公告list
const project_notice_list = () => import("@/view/winBidInvalid/notice-list")
//无效中标公告查看和编辑
const project_win_bid_invalid_notice_edit = () => import("@/view/winBidInvalid/notice-edit")


//标后变更中标人申请列表
const project_win_bid_announcement_modify_list = () => import("@/view/winBidAnnouncementModifyExtend/win-bid-announcement-modify-list")
//标后变更中标人申请详细信息
const project_win_bid_announcement_modify_info = () => import("@/view/winBidAnnouncementModifyExtend/win-bid-announcement-modify-info")

//资审复评结果列表
const re_qualification_audit_record_list = () => import("@/view/evaluation/reQualificationAuditRecord/re-qualification-audit-record-list")
//资审复评结果编辑
const re_qualification_audit_record_edit = () => import("@/view/evaluation/reQualificationAuditRecord/re-qualification-audit-record-edit")
//资审复评结果查看re-
const re_qualification_audit_record_view = () => import("@/view/evaluation/reQualificationAuditRecord/re-qualification-audit-record-view")



const projectEntryRouter = {
  path: '/project-entry',
  name: 'project-entry',
  component: project_entry,
  children: [{
      path: 'project-info',
      name: 'project-info',
      component: project_edit
    },
    {
      path: 'carry-out-notice-edit/:type',
      name: 'carry-out-notice-edit',
      component: carry_out_notice_edit
    },
    //项目概况执行通知书查看跳转页面
    // {
    //   path: 'carry-out-notice-assign-view-entry',
    //   name: 'carry-out-notice-assign-view-entry',
    //   component: carry_out_notice_assign_view,
    // },
    {
      path: 'nopower',
      name: 'nopower',
      component: no_power,
    },
    {
      path: 'project-filed-edit',
      name: 'project-filed-edit',
      component: project_filed_edit
    },
    {
      path: 'project-filed-view',
      name: 'project-filed-view',
      component: project_filed_view
    },
    {
      path: 'price-form-list',
      name: 'price-form-list',
      component: price_form_list,
    },
    {
      path: 'price-form-detail/:type',
      name: 'price-form-detail',
      component: price_form_detail,
    },
    //邀请书及文件编制
    {
      path: 'procrement-file-detail-invitation-list',
      name: 'procrement-file-detail-invitation-list',
      component: procrement_file_detail_invitation_list
    },
    {
      path: 'procrement-file-detail-invitation-bid-notice/:type',
      name: 'procrement-file-detail-invitation-bid-notice',
      component: procrement_file_detail_invitation_bid_notice
    },
    {
      path: 'procrement-file-detail-invitation-bid-company/:type',
      name: 'procrement-file-detail-invitation-bid-company',
      component: procrement_file_detail_invitation_bid_company
    },
    {
      path: 'procrement-file-detail-invitation-bid-file/:type',
      name: 'procrement-file-detail-invitation-bid-file',
      component: procrement_file_detail_invitation_bid_file
    },
    {
      path: 'procrement-file-detail-invitation-competition-notice/:type',
      name: 'procrement-file-detail-invitation-competition-notice',
      component: procrement_file_detail_invitation_competition_notice
    },
    {
      path: 'procrement-file-detail-invitation-competition-company/:type',
      name: 'procrement-file-detail-invitation-competition-company',
      component: procrement_file_detail_invitation_competition_company
    },
    {
      path: 'procrement-file-detail-invitation-competition-file/:type',
      name: 'procrement-file-detail-invitation-competition-file',
      component: procrement_file_detail_invitation_competition_file
    },
    {
      path: 'procrement-file-detail-invitation-inquiry-notice/:type',
      name: 'procrement-file-detail-invitation-inquiry-notice',
      component: procrement_file_detail_invitation_inquiry_notice
    },
    {
      path: 'procrement-file-detail-invitation-inquiry-company/:type',
      name: 'procrement-file-detail-invitation-inquiry-company',
      component: procrement_file_detail_invitation_inquiry_company
    },
    {
      path: 'procrement-file-detail-invitation-inquiry-file/:type',
      name: 'procrement-file-detail-invitation-inquiry-file',
      component: procrement_file_detail_invitation_inquiry_file
    },
    {
      path: 'procrement-file-detail-invitation-negotiation-notice/:type',
      name: 'procrement-file-detail-invitation-negotiation-notice',
      component: procrement_file_detail_invitation_negotiation_notice
    },
    {
      path: 'procrement-file-detail-invitation-negotiation-company/:type',
      name: 'procrement-file-detail-invitation-negotiation-company',
      component: procrement_file_detail_invitation_negotiation_company
    },
    {
      path: 'procrement-file-detail-invitation-negotiation-file/:type',
      name: 'procrement-file-detail-invitation-negotiation-file',
      component: procrement_file_detail_invitation_negotiation_file
    },
    {
      path: 'procrement-file-detail-invitation-onesource-notice/:type',
      name: 'procrement-file-detail-invitation-onesource-notice',
      component: procrement_file_detail_invitation_onesource_notice
    },
    {
      path: 'procrement-file-detail-invitation-onesource-company/:type',
      name: 'procrement-file-detail-invitation-onesource-company',
      component: procrement_file_detail_invitation_onesource_company
    },
    {
      path: 'procrement-file-detail-invitation-onesource-file/:type',
      name: 'procrement-file-detail-invitation-onesource-file',
      component: procrement_file_detail_invitation_onesource_file
    },
    {
      path: 'procrement-file-detail-invitation-pretrial-notice/:type',
      name: 'procrement-file-detail-invitation-pretrial-notice',
      component: procrement_file_detail_invitation_pretrial_notice
    },
    {
      path: 'procrement-file-detail-invitation-pretrial-company/:type',
      name: 'procrement-file-detail-invitation-pretrial-company',
      component: procrement_file_detail_invitation_pretrial_company
    },
    {
      path: 'procrement-file-detail-invitation-pretrial-file/:type',
      name: 'procrement-file-detail-invitation-pretrial-file',
      component: procrement_file_detail_invitation_pretrial_file
    },
    //公告及文件
    {
      path: 'procrement-file-detail',
      name: 'procrement-file-detail',
      component: procrement_file_detail
    },
    {
      path: 'procrement-file-detail-notice/:type',
      name: 'procrement-file-detail-notice',
      component: procrement_file_detail_notice
    },
    {
      path: 'procrement-file-detail-file/:type',
      name: 'procrement-file-detail-file',
      component: procrement_file_detail_file
    },
    {
      path: 'procrement-file-detail-contest',
      name: 'procrement-file-detail-contest',
      component: procrement_file_detail_contest
    },
    {
      path: 'procrement-notice-contest-pdf',
      name: 'procrement-notice-contest-pdf',
      component: procrement_notice_contest_pdf
    },
    {
      path: 'procrement-notice-contest-invitation',
      name: 'procrement-notice-contest-invitation',
      component: procrement_notice_contest_invitation
    },
    {
      path: 'procrement-notice-contest-invitation-pdf',
      name: 'procrement-notice-contest-invitation-pdf',
      component: procrement_notice_contest_invitation_pdf
    },
    {
      path: 'procrement-file-detail-competition-notice/:type',
      name: 'procrement-file-detail-competition-notice',
      component: procrement_file_detail_competition_notice
    },
    {
      path: 'procrement-file-detail-competition-file/:type',
      name: 'procrement-file-detail-competition-file',
      component: procrement_file_detail_competition_file
    },
    {
      path: 'procrement-file-detail-negotiation-notice/:type',
      name: 'procrement-file-detail-negotiation-notice',
      component: procrement_file_detail_negotiation_notice
    },
    {
      path: 'procrement-file-detail-negotiation-file/:type',
      name: 'procrement-file-detail-negotiation-file',
      component: procrement_file_detail_negotiation_file
    },
    {
      path: 'procrement-file-detail-inquiry-file/:type',
      name: 'procrement-file-detail-inquiry-file',
      component: procrement_file_detail_inquiry_file
    },
    {
      path: 'procrement-file-detail-onesource-notice/:type',
      name: 'procrement-file-detail-onesource-notice',
      component: procrement_file_detail_onesource_notice
    },
    {
      path: 'procrement-file-detail-inquiry-notice/:type',
      name: 'procrement-file-detail-inquiry-notice',
      component: procrement_file_detail_inquiry_notice
    },
    {
      path: 'procrement-file-detail-onesource-file/:type',
      name: 'procrement-file-detail-onesource-file',
      component: procrement_file_detail_onesource_file
    },
    {
      path: 'procrement-file-detail-competition-pdf',
      name: 'procrement-file-detail-competition-pdf',
      component: procrement_file_detail_competition_pdf
    },
    {
      path: 'procrement-file-detail-notcarry-pdf',
      name: 'procrement-file-detail-notcarry-pdf',
      component: procrement_file_detail_notcarry_pdf
    },

    {
      path: 'procrement-file-detail-competition-invitation',
      name: 'procrement-file-detail-competition-invitation',
      component: procrement_file_detail_competition_invitation
    },
    {
      path: 'procrement-file-detail-competition-invitation-pdf',
      name: 'procrement-file-detail-competition-invitation-pdf',
      component: procrement_file_detail_competition_invitation_pdf
    },
    {
      path: 'procrement-file-detail-inquiry',
      name: 'procrement-file-detail-inquiry',
      component: procrement_file_detail_inquiry
    },
    {
      path: 'procrement-file-detail-inquiry-pdf',
      name: 'procrement-file-detail-inquiry-pdf',
      component: procrement_file_detail_inquiry_pdf
    },
    {
      path: 'procrement-file-detail-inquiry-invitation',
      name: 'procrement-file-detail-inquiry-invitation',
      component: procrement_file_detail_inquiry_invitation
    },
    {
      path: 'procrement-file-detail-inquiry-invitation-pdf',
      name: 'procrement-file-detail-inquiry-invitation-pdf',
      component: procrement_file_detail_inquiry_invitation_pdf
    },
    {
      path: 'procrement-file-detail-onsource',
      name: 'procrement-file-detail-onsource',
      component: procrement_file_detail_onesource
    },
    {
      path: 'procrement-file-detail-onsource-pdf',
      name: 'procrement-file-detail-onsource-pdf',
      component: procrement_file_detail_onesource_pdf
    },
    {
      path: 'review-expert-registration-list',
      name: 'review-expert-registration-list',
      component: review_expert_registration_list
    },
    {
      path: 'review-expert-registration-edit',
      name: 'review-expert-registration-edit',
      component: review_expert_registration_edit
    },
    {
      path: 'contract-publicity-list',
      name: 'contract-publicity-list',
      component: contract_publicity_list
    },
    {
      path: 'contract-publicity-edit',
      name: 'contract-publicity-edit',
      component: contract_publicity_edit
    },
    {
      path: 'contract-publicity-view',
      name: 'contract-publicity-view',
      component: contract_publicity_view
    },
    {
      path: 'contract-publicity-pdf',
      name: 'contract-publicity-pdf',
      component: contract_publicity_pdf
    },
    {
      path: 'contract-publicity-pdffzr',
      name: 'contract-publicity-pdffzr',
      component: contract_publicity_pdffzr
    },
    {
      path: 'qualification-audit-record-list',
      name: 'qualification-audit-record-list',
      component: qualification_audit_record_list
    },
    {
      path: 'qualification-audit-record-edit',
      name: 'qualification-audit-record-edit',
      component: qualification_audit_record_edit
    },
    {
      path: 'qualification-audit-record-view',
      name: 'qualification-audit-record-view',
      component: qualification_audit_record_view
    },
    {
      path: 'answer-project-list',
      name: 'answer-project-list',
      component: answer_project_list
    },
    {
      path: 'answer-project-reply',
      name: 'answer-project-reply',
      component: answer_project_reply
    },
    {
      path: 'answer-project-receipt',
      name: 'answer-project-receipt',
      component: answer_project_receipt
    },

    {
      path: 'answer-project-detail',
      name: 'answer-project-detail',
      component: answer_project_detail
    },
    {
      path: 'evaluation-bid-result-list',
      name: 'evaluation-bid-result-list',
      component: evaluation_bid_result_list
    },
    {
      path: 'evaluation-bid-result-edit',
      name: 'evaluation-bid-result-edit',
      component: evaluation_bid_result_edit
    },
    {
      path: 'evaluation-bid-result-view',
      name: 'evaluation-bid-result-view',
      component: evaluation_bid_result_view
    },
    {
      path: 'open-bid-result-list',
      name: 'open-bid-result-list',
      component: open_bid_result_list
    },
    {
      path: 'open-bid-result-edit',
      name: 'open-bid-result-edit',
      component: open_bid_result_edit
    },
    {
      path: 'open-bid-result-view',
      name: 'open-bid-result-view',
      component: open_bid_result_view
    },
    {
      path: 'enroll-view-list',
      name: 'enroll-view-list',
      component: enroll_view_list
    },
    {
      path: 'win-bid-announcement-edit',
      name: 'win-bid-announcement-edit',
      component: win_bid_announcement_edit
    },
    {
      path: 'win-bid-announcement-release',
      name: 'win-bid-announcement-release',
      component: win_bid_announcement_release
    },
    {
      path: 'win-bid-announcement-release',
      name: 'win-bid-announcement-release',
      component: win_bid_announcement_release
    },
    {
      path: 'win-bid-announcement-list',
      name: 'win-bid-announcement-list',
      component: win_bid_announcement_list
    },
    {
      path: 'project-arguement-first',
      name: 'project-arguement-first',
      component: project_arguement_first
    },
    {
      path: 'project-arguement-second',
      name: 'project-arguement-second',
      component: project_arguement_second
    },
    {
      path: 'survey-result-record-list',
      name: 'survey-result-record-list',
      component: survey_result_record_list
    },
    {
      path: 'survey-result-record-edit',
      name: 'survey-result-record-edit',
      component: survey_result_record_edit
    },
    {
      path: 'survey-result-record-view',
      name: 'survey-result-record-view',
      component: survey_result_record_view
    },
    {
      path: 'win-bid-notice-modify-list',
      name: 'win-bid-notice-modify-list',
      component: win_bid_notice_modify_list
    },
    {
      path: 'win-bid-notice-modify-edit',
      name: 'win-bid-notice-modify-edit',
      component: win_bid_notice_modify_edit
    },
    {
      path: 'win-bid-notice-modify-pdf',
      name: 'win-bid-notice-modify-pdf',
      component: win_bid_notice_modify_pdf
    },
    {
      path: 'win-bid-notice-modify-view-pdf',
      name: 'win-bid-notice-modify-view-pdf',
      component: win_bid_notice_modify_view_pdf
    },
    {
      path: 'win-bid-notice-modify-view',
      name: 'win-bid-notice-modify-view',
      component: win_bid_notice_modify_view
    },

    {
      path: 'nullifield-bid-list',
      name: 'nullifield-bid-list',
      component: nullifield_bid_list
    },
    {
      path: 'nullifield-bid-edit',
      name: 'nullifield-bid-edit',
      component: nullifield_bid_edit
    },
    {
      path: 'nullifield-bid-view',
      name: 'nullifield-bid-view',
      component: nullifield_bid_view
    },
    {
      path: 'reaccreditation-conclusion-list',
      name: 'reaccreditation-conclusion-list',
      component: reaccreditation_conclusion_list
    },
    {
      path: 'reaccreditation-conclusion-edit',
      name: 'reaccreditation-conclusion-edit',
      component: reaccreditation_conclusion_edit
    },
    {
      path: 'reaccreditation-conclusion-view',
      name: 'reaccreditation-conclusion-view',
      component: reaccreditation_conclusion_view
    },
    {
      path: 'reaccreditation-apply-list',
      name: 'reaccreditation-apply-list',
      component: reaccreditation_apply_list
    },
    {
      path: 'reaccreditation-apply-edit',
      name: 'reaccreditation-apply-edit',
      component: reaccreditation_apply_edit
    },
    {
      path: 'reaccreditation-apply-view',
      name: 'reaccreditation-apply-view',
      component: reaccreditation_apply_view
    },
    {
      path: 'change-judge-application-edit',
      name: 'change-judge-application-edit',
      component: change_judge_application_edit
    },
    {
      path: 'change-judge-application-list',
      name: 'change-judge-application-list',
      component: change_judge_application_list
    },
    {
      path: 'change-purchaser-mode-edit',
      name: 'change-purchaser-mode-edit',
      component: change_purchaser_mode_edit
    },

    {
      path: 'mod-correction-view',
      name: 'mod-correction-view',
      component: modify_correction_view
    },
    {
      path: 'modify-notice-list',
      name: 'modify-notice-list',
      component: modify_notice_list
    },
    {
      path: 'modify-notice-edit',
      name: 'modify-notice-edit',
      component: modify_notice_edit
    },
    {
      path: 'modify-notice-view',
      name: 'modify-notice-view',
      component: modify_notice_view
    },
    {

      path: 'modify-notice-pdf',
      name: 'modify-notice-pdf',
      component: modify_notice_pdf
    },
    {
      path: 'modify-notice-contest-list',
      name: 'modify-notice-contest-list',
      component: modify_notice_contest_list
    },
    {
      path: 'modify-notice-contest-edit',
      name: 'modify-notice-contest-edit',
      component: modify_notice_contest_edit
    },
    {
      path: 'mod-contest-correction-view',
      name: 'mod-contest-correction-view',
      component: modify_contest_correction_view
    },
    {
      path: 'modify-notice-contest-view',
      name: 'modify-notice-contest-view',
      component: modify_notice_contest_view
    },
    {

      path: 'modify-notice-contest-pdf',
      name: 'modify-notice-contest-pdf',
      component: modify_notice_contest_pdf
    },

    {
      path: 'mod-competion-correction-view',
      name: 'mod-competion-correction-view',
      component: mod_competion_correction_view
    },
    {
      path: 'modify-notice-competition-list',
      name: 'modify-notice-competition-list',
      component: modify_notice_competition_list
    },
    {
      path: 'modify-notice-competition-edit',
      name: 'modify-notice-competition-edit',
      component: modify_notice_competition_edit
    },
    {
      path: 'modify-notice-competition-view',
      name: 'modify-notice-competition-view',
      component: modify_notice_competition_view
    },
    {

      path: 'modify-notice-competition-pdf',
      name: 'modify-notice-competition-pdf',
      component: modify_notice_competition_pdf
    },

    {
      path: 'monify-notice-info',
      name: 'monify-notice-info',
      component: monify_notice_info
    },
    {
      path: 'purchase-agency',
      name: 'purchase-agency',
      component: purchase_agency
    }, {
      path: 'purchaser-connector',
      name: 'purchaser-connector',
      component: purchaser_connector
    }, {
      path: 'project-info',
      name: 'project-info',
      component: project_info
    },
    {
      path: 'mod-invite-correction-view',
      name: 'mod-invite-correction-view',
      component: modify_invite_correction_view
    },
    {
      path: 'modify-notice-invite-list',
      name: 'modify-notice-invite-list',
      component: modify_notice_invite_list
    },
    {
      path: 'modify-notice-invite-edit',
      name: 'modify-notice-invite-edit',
      component: modify_notice_invite_edit
    },
    {
      path: 'modify-notice-invite-view',
      name: 'modify-notice-invite-view',
      component: modify_notice_invite_view
    },
    {

      path: 'modify-notice-invite-pdf',
      name: 'modify-notice-invite-pdf',
      component: modify_notice_invite_pdf
    },
    {
      path: 'mod-inquiry-correction-view',
      name: 'mod-inquiry-correction-view',
      component: modify_inquiry_correction_view
    },
    {
      path: 'modify-notice-inquiry-list',
      name: 'modify-notice-inquiry-list',
      component: modify_notice_inquiry_list
    },
    {
      path: 'modify-notice-inquiry-edit',
      name: 'modify-notice-inquiry-edit',
      component: modify_notice_inquiry_edit
    },
    {
      path: 'modify-notice-inquiry-view',
      name: 'modify-notice-inquiry-view',
      component: modify_notice_inquiry_view
    },
    {

      path: 'modify-notice-inquiry-pdf',
      name: 'modify-notice-inquiry-pdf',
      component: modify_notice_inquiry_pdf
    },

    {
      path: 'mod-onesource-correction-view',
      name: 'mod-onesource-correction-view',
      component: modify_onesource_correction_view
    },
    {
      path: 'modify-notice-onesource-list',
      name: 'modify-notice-onesource-list',
      component: modify_notice_onesource_list
    },
    {
      path: 'modify-notice-onesource-edit',
      name: 'modify-notice-onesource-edit',
      component: modify_notice_onesource_edit
    },
    {
      path: 'modify-notice-onesource-view',
      name: 'modify-notice-onesource-view',
      component: modify_notice_onesource_view
    },
    {

      path: 'modify-notice-onesource-pdf',
      name: 'modify-notice-onesource-pdf',
      component: modify_notice_onesource_pdf
    },
    {
      path: 'qualification-audit-notice-modify-list',
      name: 'qualification-audit-notice-modify-list',
      component: qualification_audit_notice_modify_list
    },
    {
      path: 'qualification-audit-notice-modify-edit',
      name: 'qualification-audit-notice-modify-edit',
      component: qualification_audit_notice_modify_edit
    },
    {
      path: 'qualification-audit-modify-correction-view',
      name: 'qualification-audit-modify-correction-view',
      component: qualification_audit_modify_correction_view
    },
    {
      path: 'qualification-purchase-agency',
      name: 'qualification-purchase-agency',
      component: qualification_purchase_agency
    },
    {
      path: 'qualification-monify-notice-info',
      name: 'qualification-monify-notice-info',
      component: qualification_monify_notice_info
    },
    {
      path: 'qualification-project-info',
      name: 'qualification-project-info',
      component: qualification_project_info
    },
    {
      path: 'qualification-purchaser-connector',
      name: 'qualification-purchaser-connector',
      component: qualification_purchaser_connector
    },


    {
      path: 'qualification-audit-notice-modify-view',
      name: 'qualification-audit-notice-modify-view',
      component: qualification_audit_notice_modify_view
    },
    {

      path: 'qualification-audit-notice-modify-pdf',
      name: 'qualification-audit-notice-modify-pdf',
      component: qualification_audit_notice_modify_pdf
    },
    {
      path: 'project-correction-view',
      name: 'project-correction-view',
      component: project_correction_view
    }, {
      path: 'qualification-audit-correction-view',
      name: 'qualification-audit-correction-view',
      component: qualification_audit_correction_view
    },
    {
      path: 'change-purchaser-mode-list',
      name: 'change-purchaser-mode-list',
      component: change_purchaser_mode_list
    },
    {
      path: 'project-venue-book-reserve',
      name: 'project-venue-book-reserve',
      component: project_venue_book_reserve
    },
    {
      path: 'project-venue-book-venue',
      name: 'project-venue-book-venue',
      component: project_venue_book_venue
    },
    {
      path: 'venue-book',
      component: venue_book,
      children: [{
          path: '/',
          component: venue_book_list
        },
        {
          path: ':type/:model',
          component: venue_book_info
        }
      ]
    },
    {
      path: 'venue-book-review',
      component: venue_book_review,
      children: [{
          path: '/',
          component: venue_book_review_list
        },
        {
          path: ':type/:model',
          component: venue_book_review_info
        }
      ]
    },
    {
      path: 'venue-book-single',
      component: venue_book_single,
      children: [{
          path: '/',
          component: venue_book_single_list
        },
        {
          path: ':type/:model',
          component: venue_book_single_info
        }
      ]
    },
    //资审公告及文件
    {
      path: 'procrement-file-detail-review',
      name: 'procrement-file-detail-review',
      component: procrement_file_detail_review
    },
    {
      path: 'procrement-file-detail-review-notice/:type',
      name: 'procrement-file-detail-review-notice',
      component: procrement_file_detail_review_notice
    },
    {
      path: 'procrement-file-detail-review-file/:type',
      name: 'procrement-file-detail-review-file',
      component: procrement_file_detail_review_file
    },
    {
      path: 'single-source-notice-main',
      name: 'single-source-notice-main',
      component: single_source_notice_main
    },
    {
      path: 'single-source-notice-view',
      name: 'single-source-notice-view',
      component: single_source_notice_view
    },
    {
      path: 'single-source-notice-edit',
      name: 'single-source-notice-edit',
      component: single_source_notice_edit
    },
    {
      path: 'single-source-notice-apply-view',
      name: 'single-source-notice-apply-view',
      component: single_source_notice_apply_view
    },
    {
      path: 'qualification-audit-detail',
      name: 'qualification-audit-detail',
      component: qualification_audit_detail
    },
    {
      path: 'procrement-notice-invitation-pretrial-list',
      name: 'procrement-notice-invitation-pretrial-list',
      component: procrement_notice_invitation_pretrial_list
    },
    {
      path: 'procrement-notice-invitation-pretrial',
      name: 'procrement-notice-invitation-pretrial',
      component: procrement_notice_invitation_pretrial
    },
    {
      path: 'procrement-notice-invitation-two-envelope',
      name: 'procrement-notice-invitation-two-envelope',
      component: procrement_notice_invitation_two_envelope
    },
    {
      path: 'procrement-notice-invitation-two-envelope-pdf',
      name: 'procrement-notice-invitation-two-envelope-pdf',
      component: procrement_notice_invitation_two_envelope_pdf
    },

    {
      path: 'procrement-notice-invitation-pretrial-pdf',
      name: 'procrement-notice-invitation-pretrial-pdf',
      component: procrement_notice_invitation_pretrial_pdf
    },


    {
      path: 'qualification-audit-contest-pdf',
      name: 'qualification-audit-contest-pdf',
      component: qualification_audit_contest_pdf
    },
    {
      path: 'project-filed-main',
      name: 'project_filed-main',
      component: project_filed_main
    },
    {
      path: 'project-filed-tender-edit',
      name: 'project-filed-tender-edit',
      //project_filed_tender_edit
      component: ademo
    },
    {
      path: 'project-filed-tender-view',
      name: 'project-filed-tender-view',
      component: project_filed_tender_view
    },
    {
      path: 'project-filed-tender-pdf',
      name: 'project-filed-tender-pdf',
      component: project_filed_tender_pdf
    },

    {
      path: 'purchase-file-verification-edit',
      name: 'purchase-file-verification-edit',
      component: purchase_file_verification_edit
    },
    {
      path: 'information-file-verification-edit',
      name: 'information-file-verification-edit',
      component: information_file_verification_edit
    },
    {
      path: 'project-notice-list',
      name: 'project-notice-list',
      component: project_notice_list
    },
    {
      path: 'project-win-bid-invalid-notice-edit',
      name: 'project-win-bid-invalid-notice-edit',
      component: project_win_bid_invalid_notice_edit
    },
      {
          path: 'project-win-bid-announcement-modify-list',
          name: 'project-win-bid-announcement-modify-list',
          component: project_win_bid_announcement_modify_list
      },
      {
          path: 'project-win-bid-announcement-modify-info',
          name: 'project-win-bid-announcement-modify-info',
          component: project_win_bid_announcement_modify_info
      },
      {
          path: 're-qualification-audit-record-list',
          name: 're-qualification-audit-record-list',
          component: re_qualification_audit_record_list
      },
      {
          path: 're-qualification-audit-record-edit',
          name: 're-qualification-audit-record-edit',
          component: re_qualification_audit_record_edit
      },
      {
          path: 're-qualification-audit-record-view',
          name: 're-qualification-audit-record-view',
          component: re_qualification_audit_record_view
      },
  ]
}
export default projectEntryRouter



// WEBPACK FOOTER //
// ./src/router/src/projectEntry.js